import { useState } from "react";
import Modalstructure from "../../../components/structure";
import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import SubmitButton from "../../../../button/SubmitButton";
import ApiDatabase from "../../../../../server";

const ModalDeleteMission = ({ isOpen, onClose, mission, onDeleted }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = () => {
    if (!mission?._id) return;
    setSubmitting(true);
    setError("");
    ApiDatabase.deleteMission(
      { id: mission._id },
      () => {
        setSubmitting(false);
        onDeleted?.();
      },
      (err) => {
        setSubmitting(false);
        setError(
          err?.response?.data?.message ||
            "Impossible de supprimer cette mission."
        );
      }
    );
  };

  return (
    <Modalstructure isShowing={isOpen}>
      <Modalheader hide={onClose} hideShow>
        Supprimer la mission
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-2">
          <div className="ft-sm text-gray-700">
            Cette action est irréversible. La mission ne sera plus visible dans le
            suivi horaire.
          </div>
          {error ? <div className="ft-sm text-red-600">{error}</div> : null}
        </div>
      </ModalBody>
      <ModalFooter>
        <>
          <Button color="SECONDARY" size="LG" onClick={onClose}>
            Annuler
          </Button>
          <SubmitButton loading={submitting} onClick={handleDelete}>
            Supprimer
          </SubmitButton>
        </>
      </ModalFooter>
    </Modalstructure>
  );
};

export default ModalDeleteMission;
